module.exports = __webpack_public_path__ + "img/icon_whjy.3e201bf9.png";